import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { TOKEN_KEY, USER_ROLE_KEY } from '../../utils/constants';

const ParentPrivateRoute: React.FC = () => {
    const token = localStorage.getItem(TOKEN_KEY);
    const role = localStorage.getItem(USER_ROLE_KEY);

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    if (role !== 'parent') {
        // Redirect to appropriate dashboard based on role
        if (role === 'student') return <Navigate to="/dashboard" replace />;
        if (role === 'admin') return <Navigate to="/admin-dashboard" replace />;
        if (role === 'ep') return <Navigate to="/ep-dashboard" replace />;
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default ParentPrivateRoute;
